import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {FacadeService} from "../shared/service-facade/facade.service";
import {environment} from "../../environments/environment";
import {HomepageEnum} from "../shared/model/homepage.enum";
import {BASK_URL_CHECK} from "../shared/constants";

@Injectable({
  providedIn: 'root'
})
export class ExistingAppGuard implements CanActivate {

  constructor(private facade: FacadeService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const sessionId = this.facade.getSessionId();

    if (!sessionId || sessionId === "") {
      if(window.location.href.toString().toLowerCase().indexOf(BASK_URL_CHECK) != -1) window.location.href = HomepageEnum.BASK;
      else window.location.href = HomepageEnum.TCB_PRODUCT_SELECTION;

      return false;
    }

    return true;
  }

}
